import { SITE } from "@/lib/site";

const WhatsAppIcon = ({ className = "h-6 w-6" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.768.967-.941 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413"/>
  </svg>
);

export default function FloatingButtons() {
  const companyNumber = (SITE.whatsapp || "+905375466156").replace(/\D/g, "");
  const companyMsg = encodeURIComponent("Merhaba, Kardeşler Yapı için bilgi almak istiyorum.");
  const devNumber = "905317832908";
  const devMsg = encodeURIComponent("Merhaba CodexsanAPP, web yazılımı hakkında bilgi almak istiyorum.");

  return (
    <>
      <a
        href={`https://wa.me/${companyNumber}?text=${companyMsg}`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="float-whatsapp"
        aria-label="WhatsApp ile iletişime geç"
        className="fixed bottom-6 right-6 z-[55] group"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-50 animate-ping" />
        <span className="relative flex items-center gap-3 bg-[#25D366] text-white rounded-full py-3 px-4 shadow-2xl ring-2 ring-[#25D366]/40 hover:ring-white/40 transition group-hover:pl-5 group-hover:pr-6">
          <WhatsAppIcon className="h-6 w-6" />
          <span className="hidden md:inline font-display tracking-[0.18em] uppercase text-xs whitespace-nowrap">WhatsApp</span>
        </span>
      </a>

      <a
        href={`https://wa.me/${devNumber}?text=${devMsg}`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="float-developer"
        aria-label="Geliştirici CodexsanAPP WhatsApp"
        className="fixed bottom-6 left-6 z-[55] group"
      >
        <span className="relative flex items-center gap-3 bg-[#0a0a0a] border border-[#d4af37]/40 hover:border-[#d4af37] text-white rounded-2xl pl-1 pr-4 py-1 shadow-2xl transition">
          <span className="relative h-12 w-12 rounded-full bg-white flex items-center justify-center ring-2 ring-[#d4af37]/40 shrink-0 overflow-hidden">
            <svg viewBox="0 0 64 64" className="h-9 w-9" aria-hidden="true">
              <defs>
                <linearGradient id="cxg" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0%" stopColor="#3b82f6" />
                  <stop offset="50%" stopColor="#6366f1" />
                  <stop offset="100%" stopColor="#8b5cf6" />
                </linearGradient>
              </defs>
              <path d="M32 6 L52 18 L52 42 L32 54 L12 42 L12 18 Z" fill="none" stroke="url(#cxg)" strokeWidth="3" strokeLinejoin="round" />
              <path d="M22 24 L18 30 L22 36 M42 24 L46 30 L42 36 M28 38 L36 22" fill="none" stroke="url(#cxg)" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </span>
          <span className="leading-tight">
            <span className="block font-mono text-[9px] uppercase tracking-[0.28em] text-white/55">Geliştiren</span>
            <span className="block font-display text-base tracking-tight">
              <span className="text-white">Codexsan</span>
              <span style={{ background: "linear-gradient(90deg,#3b82f6,#8b5cf6)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>APP</span>
            </span>
          </span>
        </span>
      </a>
    </>
  );
}
